export var ReportFormat;
(function (ReportFormat) {
    ReportFormat["Csv"] = "csv";
    ReportFormat["Excel"] = "xlsx";
    ReportFormat["Pdf"] = "pdf";
    ReportFormat["PowerPoint"] = "powerpoint";
    ReportFormat["Word"] = "docx";
    ReportFormat["Img"] = "img";
})(ReportFormat || (ReportFormat = {}));
export var AsyncActivity;
(function (AsyncActivity) {
    AsyncActivity["FileDownload"] = "file-download";
    AsyncActivity["QuantAnalysisFileUpload"] = "quant-analysis-file-upload";
})(AsyncActivity || (AsyncActivity = {}));
